// Notes éditoriales de cette interface. Ajouter un ID stable pour chaque nouvelle livraison.
export default {
    "interface": "caisse",
    "label": "Caisse",
    "entries": [
        {
            "id": "billetage-cartes-20261009",
            "date": "2026-10-09",
            "title": "Billétage en cartes pour tous les pays",
            "description": "Quel que soit le pays configuré, chaque devise dispose de sa propre carte avec les colonnes Quantité, Coupure et Montant, les billets et les pièces regroupés, et un total par devise. Les deux devises s’affichent côte à côte, sans bouton de bascule. Avec une seule devise, les billets et les pièces apparaissent dans deux cartes côte à côte, chacune avec son total.",
            "location": "Caisse → Versement / Billétage."
        },
        {
            "id": "dettes-ui-20260921",
            "date": "2026-09-21",
            "title": "Dettes : une synthèse comme en Trésorerie",
            "description": "Retrouvez les trois onglets Fournisseurs, Prestataires et Prescripteurs. Quatre cartes affichent le montant dû, le payé, le restant et le nombre de dettes selon les filtres. Cliquez sur une ligne pour ouvrir ses détails en popup ; le menu ⋮ conserve les actions disponibles.",
            "location": "Dettes."
        },
        {
            "id": "remunerations-20260921",
            "date": "2026-09-21",
            "title": "Rémunérations : détail des prestations et paiement",
            "description": "Les rémunérations prestataires présentent les patients, les numéros de dossier et les actes regroupés par prestation, avec leurs totaux. Pour les utilisateurs Trésorerie autorisés, Payer ouvre Dépenses avec la ligne système Rémunération Prestataires présélectionnée. Aucun paiement n’est effectué à l’ouverture.",
            "location": "Dettes → Prestataires → détails d’une rémunération."
        },
        {
            "id": "billetage-rdc-20260921",
            "date": "2026-09-21",
            "title": "Billétage CDF et USD côte à côte",
            "description": "Lorsque le pays configuré est Congo-Kinshasa, les coupures CDF et USD apparaissent dans deux cartes simultanées, sans bouton de bascule. Les autres pays conservent leur présentation habituelle. Le rapport reprend les détails du billétage.",
            "location": "Caisse → Versement / Billétage."
        },
        {
            "id": "patient-postnom-20260921",
            "date": "2026-09-21",
            "title": "Nom & Postnom dans le formulaire Assuré",
            "description": "Le libellé Nom & Postnom est harmonisé pour l’assuré principal, le malade, l’accompagnant et la personne à prévenir, selon le pays configuré. Les prénoms restent dans leur champ dédié.",
            "location": "Ajouter ou modifier un patient assuré."
        },
        {
            "id": "nouveautes-20260921",
            "date": "2026-09-21",
            "title": "Les nouveautés à portée de clic",
            "description": "La cloche du header ouvre les améliorations propres à cette interface. Le compteur rouge indique les notifications non lues. Vous pouvez les marquer comme lues individuellement ou toutes à la fois ; la liste reste disponible à tout moment.",
            "location": "Cloche en haut de l’écran. La lecture est mémorisée sur ce navigateur pour votre compte."
        }
    ]
}
